// Department
export const apiGetAllDept = "Department/GetAllForCombobox"
